module.exports = __webpack_public_path__ + "static/media/bannerImg.796dc3cc.png";